import React, { memo } from 'react'
import Page from 'components/Page'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import PostsList from 'components/PostsList'
import usePageProps from 'hooks/usePageProps'
import { useRouter } from 'next/router'
import StateFilter from './StateFilter'
import sx from './styles'
import MainBanner from './MainBanner'

const Blog = () => {
  const { posts } = usePageProps()
  const router = useRouter()

  return (
    <Page>

      <MainBanner />

      <Container maxWidth={false}>
        <Grid
          container
          mt={2}
          sx={sx.container}
        >
          <Grid
            item
            xs={12}
            md={9}
            xl={10}
            sx={sx.postsContainer}
          >
            <PostsList
              title="BLOG_TITLE"
              description="BLOG_DESCRIPTION"
              variantTitle="h2"
              componentTitle="h1"
              items={
                router?.query?.estados
                  ? posts?.filter((post) => (router?.query?.estados?.includes(post?.state_slug)))
                  : posts
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
            xl={2}
          >
            <StateFilter />
          </Grid>
        </Grid>
      </Container>

    </Page>
  )
}

export default memo(Blog)
